const autoNgTemplateLoaderTemplate1 = require('./web-editor-form.html');

import controller from './web-editor-form.controller.js';

export const webEditorForm = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,

  bindings: {
    identifier: '@',
    textTip: '@',
    yml: '<',
    value: '<',
    readOnly: '<',
    onChange: '<',
    hideTitle: '<',
    height: '@',
    schema: '<',
  },

  transclude: {
    description: '?editorDescription',
  },
};
